import React from "react";
import PropTypes from "prop-types";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { truncate } from "lodash";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import {
  DataTable,
  SearchPropTypes,
  PartNumber
} from "MODULES/shared/components";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import Warnings from "./Warnings";

function renderRow(r, pushHistory) {
  const className = getPartNumberColorClassNameByTierType(r.tier_type);
  const engineApplications = r.applications.filter(
    a => a.type === "EngineApplication"
  );
  const aircraftApplications = r.applications.filter(
    a => a.type === "AircraftApplication"
  );

  const truncatedAircraftApplications = truncate(
    aircraftApplications.map(a => a.label).join(", "),
    { length: 40 } // Specify the maximum length explicitly
  );
  return (
    <tr
      key={r.id}
      className="clickable"
      onClick={() => pushHistory(`/parts/${r.uuid}`)}
    >
      <td>
        <PartNumber part={r} className={className} showIcon />
      </td>
      <td>{r.description}</td>
      <td>{r.alternate_part_numbers}</td>
      <td>{r.manufacturer}</td>
      <Warnings part={r} />
      <td>{r.cage}</td>
      <td>{truncatedAircraftApplications}</td>
      <td>{engineApplications.map(a => a.label).join(", ")}</td>
      <td>{shortDate(r.purchased_at)}</td>
      <td className="text-right">
        {dollars(r.manufacturer_list_price, 2, true)}
      </td>
      <td className="text-right">{r.sellable_quantity}</td>
    </tr>
  );
}

export function Table({ pushHistory, isLoading, results }) {
  return (
    <DataTable loading={isLoading}>
      <DataTable.Head>
        <th>Part Number</th>
        <th>Description</th>
        <th>Alternates</th>
        <th>MFG</th>
        <th>Warnings</th>
        <th>Cage</th>
        <th>Aircraft Applications</th>
        <th>Engine Applications</th>
        <th>DOP</th>
        <th className="text-right">MLP</th>
        <th className="text-right">Sellable Qty</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Search/Table.jsx